// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1fj6V","content":"style_content__zGsHK","button":"style_button__vYvN4"};